import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import {
  AlertController,
  LoadingController,
  ModalController,
  Platform,
  PopoverController,
} from '@ionic/angular';
import { APIService } from 'src/providers/apiservices/apiservices';
import { Events } from 'src/providers/apiservices/eventsservice';
import {
  GlobalService,
  ToastColors,
} from 'src/providers/apiservices/globalservices';
import { AutorizacaoServicoProvider } from 'src/providers/autorizacaoservico/autorizacaoservico';
import { ComunicacaoProvider } from 'src/providers/comunicacao/comunicacao';
import { TarefasProvider } from 'src/providers/tarefas/tarefas';
import { CreateautorizacaoservicoPage } from '../createautorizacaoservico/createautorizacaoservico.page';
import { TimelinereadPage } from './timelineread/timelineread.page';
import {ControleCienteProvider} from "../../../providers/controleciente/controleciente";

interface Leituras {
  lidas: ComunicadoDTO.RootObject[];
  naoLidas: ComunicadoDTO.RootObject[];
}


@Component({
  selector: 'app-message',
  templateUrl: './message.page.html',
  styleUrls: ['./message.page.scss'],
})
export class MessagePage implements OnInit {
  @Input() id: string;
  @Input() mensagem: any = {};

  // TYPES
  // 1 - COMUNICAÇÃO
  // 2 - AUTORIZAÇÃO DE SERVIÇO
  // 3 - INFORME DE VENDA
  // 4 - BOLETOS E COBRANÇA
  @Input() type: number;

  @Input() isTarefa: boolean = false;
  @Input() tarefa: any = null;

  @Input() isPreview: boolean = false;

  @Input() isConfirmacaoPresenca: boolean = false;

  // Tipo 1
  sender: string = '';
  subject: string = '';
  message: SafeHtml = '';
  messages: Array<any> = [];
  leituras = {
    lidas: [],
    naoLidas: [],
  };
  loadingLeituras: boolean = false;
  totalDestinatarios: number = 0;

  // Tipo 2
  isModalJustificativa: boolean = false;
  justificativaText: string = '';
  justificativa: any;
  tipoJustificativa: string = '';
  chatInputTexto: string = '';
  colaboradores: Array<any> = [];
  colaboradorEntradas: Array<any> = [];
  veiculos: Array<any> = [];
  chatAtualSegment = 'lojista';
  chatAutorizacaoServico: Array<any> = [];
  chatAutorizacaoServicoLojistaPrint: Array<any> = [];
  chatAutorizacaoServicoInternoPrint: Array<any> = [];
  status_autorizacao = [
    {
      idStatusAutorizacaoServico: 1,
      desStatusAutorizacaoServico: 'Em Análise',
    },
    {
      idStatusAutorizacaoServico: 2,
      desStatusAutorizacaoServico: 'Aprovada',
    },
    {
      idStatusAutorizacaoServico: 3,
      desStatusAutorizacaoServico: 'Reprovada',
    },
    {
      idStatusAutorizacaoServico: 4,
      desStatusAutorizacaoServico: 'Cancelada',
    },
    {
      idStatusAutorizacaoServico: 5,
      desStatusAutorizacaoServico: 'Expirada',
    },
  ];

  public alertReprovarButtons = ['OK'];
  public alertReprovarInputs = [
    {
      placeholder: 'Digite aqui...',
    },
  ];

  // Geral
  isAdmin = false;
  autorizacaoEditada = false;
  isMobile: boolean = false;
  arquivos: Array<any> = [];
  AutorizacaoServico_Mensagens = {
    internas: [] as any[],
    lojista: [] as any[],
  };

  constructor(
    private modalCtrl: ModalController,
    private comunicacaoProvider: ComunicacaoProvider,
    private globalService: GlobalService,
    private loadingController: LoadingController,
    private popoverController: PopoverController,
    private autorizacaoProvicer: AutorizacaoServicoProvider,
    private tarefasProvider: TarefasProvider,
    private domSanitizer: DomSanitizer,
    private controleCienteProvider: ControleCienteProvider,
    private events: Events,
    private platform: Platform,
    private alertCtrl: AlertController
  ) {}

  ngOnInit() {
    if (this.platform.is('ios') || this.platform.is('android')) {
      this.isMobile = true;
    }

    this.carregarTela();
  }

  public get currentUserIsAprovador()
  {
    if(!this.tarefa)
      return false;

    return !!this.tarefa.name?.includes('Avaliar')
  }
  async carregarTela()
  {
    const usuario = APIService.UsuarioLogado.Usuario;

    this.globalService.devlog('Carregando mensagem...', this.mensagem, this.tarefa);
    this.globalService.devlog(usuario);

    if (this.mensagem == null) {
      if (this.type == 2) {
        await this.carregarMensagemAutorizacaoServicoApi(this.id);
        //await this.carregaMensagemAutorizacaoServico();
      } else {
        await this.carregarMensagemComunicadoApi(this.id);
      }

    } else {
      if (this.type == 1) {
        await this.carregaMensagemComunicado();
      } else if (this.type == 2) {
        await this.carregaMensagemAutorizacaoServico();
      }

      // Geral

      if(this.tarefa)
      {
        this.sender = this.tarefa.name;
      }
      else
      {
        this.sender = this.mensagem.sender;
      }
      this.subject = this.mensagem.title;
    }

    if (usuario.idTipoUsuario == 1) {
      this.isAdmin = true;
    }
  }

  async carregarMensagemAutorizacaoServicoApi(id: string) {
    this.autorizacaoProvicer.getById(id).then((response) => {
      if (response.erro) {
        console.error(response.erro);

        this.globalService.presentToast(
          'Não foi possível carregar o comunicado.',
          ToastColors.danger
        );

        return this.modalCtrl.dismiss();
      } else {
        let item = response.Item;

        this.mensagem = item;

        this.globalService.devlog('Mensagem', this.mensagem);

        this.sender = this.mensagem.descricao;
        this.subject = this.mensagem.nomeServico;


        this.controleCienteProvider.updateStatusControle(id, "6", true).catch(console.error);

        if (this.isConfirmacaoPresenca) {
          this.colaboradores = this.mensagem?.autorizacaoServicoColaboradors.filter(colaborador => colaborador.cpfColaborador == this.tarefa.cpf);
          this.colaboradorEntradas = this.mensagem?.autorizacaoServicoColaboradorEntradas.filter(colaborador => colaborador.cpfColaborador == this.tarefa.cpf);
        } else {
          this.colaboradores = this.mensagem?.autorizacaoServicoColaboradors || [];
          this.colaboradorEntradas = this.mensagem?.autorizacaoServicoColaboradorEntradas || [];
        }

        this.arquivos = this.mensagem?.autorizacaoServicoArquivos || [];
        this.veiculos = this.mensagem?.autorizacaoServicoCarros || [];

        return;
      }
    })
    .finally(() => {
      this.getMensagens(false);
      this.getMensagens(true);
      this.getJustificativa();
    })
  }

  async carregarMensagemComunicadoApi(id: string) {
    let loading = await this.loadingController.create({
      message: 'Carregando...',
    });

    loading.present();

    this.comunicacaoProvider
      .getComunicadoById(id)
      .then((response) => {
        if (response.erro) {
          console.error(response.erro);

          this.globalService.presentToast(
            'Não foi possível carregar o comunicado.',
            ToastColors.danger
          );

          return this.modalCtrl.dismiss();
        } else {
          let item = response.Item;

          this.mensagem = {
            ...item,
            type: item.idTipoComunicacao,
            sender: item.idOrigemNavigation.descricaoOrigem,
            title: item.titulo,
            id: item.idComunicacao,
            status: 0,
            date: item.dataComunicacao,
            // read: item.gravarLeituraLojista ? 1 : 0,
            read: 0,
            attachments:
              item.comunicacaoArquivos && item.comunicacaoArquivos.length > 0
                ? 1
                : 0,
          };

          // this.mensagem = response.Item;
          this.carregaMensagemComunicado();

          this.sender = this.mensagem.sender;
          this.subject = this.mensagem.title;
        }
      })
      .finally(() => {
        loading.dismiss();

      });
  }

  async carregaMensagemComunicado() {
    const usuario = APIService.UsuarioLogado.Usuario;

    if(this.mensagem.dataComunicacao)
    {
      this.mensagem.date = this.mensagem.dataComunicacao;
    }

    if(!this.mensagem.sender)
    {
      if(this.mensagem.idOrigemNavigation && this.mensagem.idOrigemNavigation.descricaoOrigem)
      {
        this.mensagem.sender = this.mensagem.idOrigemNavigation.descricaoOrigem;
      }
    }

    if(!this.mensagem.title)
    {
      this.mensagem.title = this.mensagem.titulo || "";
    }

    this.arquivos = this.mensagem.idComunicacaoNavigation
      ? this.mensagem.idComunicacaoNavigation.comunicacaoArquivos
      : this.mensagem.comunicacaoArquivos || [];

    // for previews only
    this.arquivos = this.arquivos || [];

    this.messages = this.mensagem.idComunicacaoNavigation
      ? this.mensagem.idComunicacaoNavigation.comunicacaoTextos
      : this.mensagem.comunicacaoTextos || [];

    if(this.mensagem.comunicacaoContratos)
    {
      if(!this.mensagem.idComunicacaoNavigation)
      {
        this.mensagem.idComunicacaoNavigation = {};

        this.mensagem.idComunicacaoNavigation.comunicacaoContratos = this.mensagem.comunicacaoContratos;
      }
    }

    var lastMessage: any = null;

    if (
      Array.isArray(
        this.mensagem.idComunicacaoNavigation
          ? this.mensagem.idComunicacaoNavigation.comunicacaoTextos
          : this.mensagem.comunicacaoTextos
      ) && this.mensagem.idComunicacaoNavigation
        ? this.mensagem.idComunicacaoNavigation.comunicacaoTextos
        : this.mensagem.comunicacaoTextos.length > 0
    ) {

      let _textos = this.mensagem.idComunicacaoNavigation?.comunicacaoTextos || this.mensagem.comunicacaoTextos || [];

      lastMessage = _textos.reduce((acc, message) => {
        if (new Date(acc.dataCriacao) < new Date(message.dataCriacao)) {
          return message;
        }
        return acc;
      });
    }

    // this.message = lastMessage ? lastMessage.texto : '';

    this.message = this.domSanitizer.bypassSecurityTrustHtml(lastMessage?.texto || "");

    this.messages = this.messages.map((message) => {
      try {
        message.texto = this.domSanitizer.bypassSecurityTrustHtml(message.texto);
        return message;
      } catch (error) {
        return message;
      }
    });


    if (usuario.idTipoUsuario == 1) {
      this.isAdmin = true;

      this.getLidos(Number(this.id || this.mensagem?.idComunicacao));
    }
    else {
      this.comunicacaoProvider
        .postLeituraComunicacaoContrato(Number(this.id || this.mensagem?.idComunicacao), this.mensagem.idEmpresa, this.mensagem.numContrato)
        .then((response) => {
          //console.log("PostLeitura", response)
          //this.getLidos(this.mensagem.idComunicacao);
        });
    }
  }

  getSituacaoAutorizacaoServico(idStatusAutorizacaoServico) {
    return (
      this.status_autorizacao.find(
        (x) => x.idStatusAutorizacaoServico == idStatusAutorizacaoServico
      )?.desStatusAutorizacaoServico || 'Em Análise'
    );
  }

  getSituacaoAutorizacaoServicoDepartamento(departamento) {
    if (departamento.aprovador == true) {
      return (
        this.status_autorizacao.find(
          (x) => x.idStatusAutorizacaoServico == departamento.idStatusAutorizacaoServico
        )?.desStatusAutorizacaoServico || 'Em Análise'
      );
    } else {
      return 'Observador';
    }
  }

  ordenaChatAutorizacaoByData(chatArray: any[]) {
    this.chatAutorizacaoServico = chatArray.sort(
      (a, b) => b.idComentario - a.idComentario
    );
    // this.chatAutorizacaoServico = chatArray.sort((a, b) => {
    //   b.dataInclusao = new Date(b.dataInclusao);
    //   a.dataInclusao = new Date(a.dataInclusao);
    //   return b.dataInclusao - a.dataInclusao;
    // })
  }

  ordenaPrintChatAutorizacaoByData(chatArray: any[], isLojista) {
    if (isLojista) {
      this.chatAutorizacaoServicoLojistaPrint = chatArray.sort(
        (a, b) => b.idComentario - a.idComentario
      );
    } else {
      this.chatAutorizacaoServicoInternoPrint = chatArray.sort(
        (a, b) => b.idComentario - a.idComentario
      );
    }
  }

  async carregaMensagemAutorizacaoServico() {
    this.colaboradores = this.mensagem?.autorizacaoServicoColaboradors || [];
    this.arquivos = this.mensagem?.autorizacaoServicoArquivos || [];
    this.veiculos = this.mensagem?.autorizacaoServicoCarros || [];

    this.getMensagens(false);
    this.getMensagens(true);
    this.getJustificativa();
  }

  get isAjustarAutorizacao(): boolean {
    if (this.tarefa) {
      return this.tarefa.name?.includes('Ajustar');
    } else {
      return false;
    }
  }

  get isAvaliarAutorizacao(): boolean {
    if (this.tarefa) {
      return this.tarefa.name?.includes('Avaliar');
    } else {
      return false;
    }
  }

  setOpenModalJustificativa(isOpen: boolean, tipoJustificativa: string = 'reprovar') {
    this.justificativaText = '';
    this.tipoJustificativa = tipoJustificativa == 'reprovar' ? 'Reprovação' : 'Cancelamento';
    this.isModalJustificativa = isOpen;
  }

  async changeStatusAutorizacao(status: 'aprovar' | 'reprovar' | 'cancelar') {
    let loading = await this.loadingController.create({
      message: 'Aguarde...',
    });

    loading.present();

    this.isModalJustificativa = false;

    let autorizacao = this.mensagem;

    if (!autorizacao) return;

    const statusObj = {
      aprovar: 2,
      cancelar: 4,
      reprovar: 3,
    };

    autorizacao.idStatusAutorizacaoServico = statusObj[status];

    autorizacao.id = null;

    var idDepartamentoAutorizacao = null;
    if (this.tarefa.taD_DISPLAY_NAME && this.isAvaliarAutorizacao) {
      idDepartamentoAutorizacao = JSON.parse(this.tarefa.taD_DISPLAY_NAME).id;
    }

    this.tarefasProvider
      .responderTarefa(autorizacao.idStatusAutorizacaoServico === 2, {
        idAutorizacaoServico: autorizacao.idAutorizacaoServico,
        idAtividadeBPM: this.tarefa['TASK.TKIID'],
        operacao: 'responderAutorizacao',
        statusAutorizacaoServico: autorizacao.idStatusAutorizacaoServico,
        idDepartamentoAutorizacao: idDepartamentoAutorizacao,
        justificativa: this.justificativaText,
      })
      .then((response) => {
        loading.dismiss();
        if (response.erro) {
          this.globalService.devlog(
            'Erro ao responder autorização',
            response.erro
          );
          this.globalService.presentToast(
            'Não foi possível finalizar a operação',
            ToastColors.danger
          );

          return;
        } else {
          this.globalService.presentToast(
            status == 'aprovar'
            ?
              'Autorização respondida com sucesso'
            :
              status == 'cancelar'
              ?
                'Autorização cancelada com sucesso'
              :
                'Autorização de Serviço rejeitada com sucesso',
            ToastColors.success
          );
        }

        this.events.publish('authorization.getAutorizacoes', {});

        this.globalService.devlog('ATT Autorização', response);
        this.mensagem.idStatusAutorizacaoServico =
          autorizacao.idStatusAutorizacaoServico;

        this.dismiss();
      })
      .catch((err) => {
        loading.dismiss();
        this.globalService.devlog('ATT Autorização ERRO', err);
        this.globalService.presentToast('Não foi possível responder a autorização', ToastColors.danger);
      })
      .finally(() => {
        this.events.publish('authorization.getAutorizacoes', {});
      });
  }

  preReplyMessage(response: 'aprovar' | 'reprovar' | 'cancelar') {
    this.globalService.showAviso({
      mensagem: `Deseja realmente ${ response } a autorização de serviço?`,
      confirmText: 'Sim',
      cancelText: 'Não'
    }, (isConfirm) => {
      if (isConfirm) {
        if (response == 'aprovar') {
          this.changeStatusAutorizacao(response);
        } else {
          this.setOpenModalJustificativa(true, response);
        }
      }
    }
  );
  }

  keyUpInput(event: any) {
    if (event.keyCode == 13) {
      this.enviarMensagem();
    }
  }

  async enviarMensagem() {
    // if(this.mensagem?.idStatusAutorizacaoServico != 1)
    // {
    //   this.globalService.presentToast('A autorização não está mais em análise, não é possível enviar mensagens.', ToastColors.danger);
    //   return;
    // }

    if (!this.chatInputTexto || this.chatInputTexto.length == 0) {
      this.globalService.presentToast(
        'Digite uma mensagem antes de submeter.',
        ToastColors.danger
      );
      return;
    }

    if (this.chatInputTexto.length > 500) {
      this.globalService.presentToast('A mensagem não pode conter mais do que 500 caracteres', ToastColors.danger);
      return;
    }

    let loading = await this.loadingController.create({
      message: 'Enviando mensagem...',
    });

    loading.present();

    this.autorizacaoProvicer
      .addUpdateComentarioAutorizacaoServico({
        idAutorizacaoServico: this.mensagem?.id || this.id,
        idTipoComentario: this.chatAtualSegment == 'lojista' ? 4 : 3,
        ComentarioInterno: this.chatAtualSegment == 'lojista' ? 0 : 1,
        DesComentario: this.chatInputTexto,
      })
      .then((res) => {
        if (!res.erro) {
          this.ordenaChatAutorizacaoByData([
            ...this.chatAutorizacaoServico,
            res.Item,
          ]);

          if (this.chatAtualSegment == 'lojista') {
            this.ordenaPrintChatAutorizacaoByData(
              [...this.chatAutorizacaoServicoLojistaPrint, res.Item],
              true
            );
          } else {
            this.ordenaPrintChatAutorizacaoByData(
              [...this.chatAutorizacaoServicoInternoPrint, res.Item],
              false
            );
          }
        } else {
          this.globalService.devlog(res);
          this.globalService.presentToast(res.erro, ToastColors.danger);
        }
      })
      .catch((err) => {
        this.globalService.devlog(err);
      })
      .finally(() => {
        loading.dismiss();
        this.chatInputTexto = '';
      });
  }

  getClassName(comentario) {
    const usuario = APIService.UsuarioLogado.Usuario;
    if (comentario.loginUsuarioInclusao == usuario.login1) {
      return 'ion-text-right';
    } else {
      return '';
    }
  }

  getPrintParagraphAlign(comentario) {
    const usuario = APIService.UsuarioLogado.Usuario;
    console.log(comentario)
    if (comentario.loginUsuarioInclusao == usuario.login1) {
      return 'right';
    } else {
      return 'left';
    }
  }

  async getMensagens(chatLojista: any) {
    if (typeof chatLojista == 'object') {
      chatLojista = chatLojista?.detail?.value == 'lojista';
    }
    this.chatAtualSegment = chatLojista ? 'lojista' : 'interno';

    let loading = await this.loadingController.create({
      message: 'Carregando...',
    });
    loading.present();

    this.autorizacaoProvicer
      .getAutorizacoesDeServicoChat(this.id, chatLojista)
      .then((response) => {
        this.globalService.devlog(response);

        if (!response.erro) {
          this.ordenaChatAutorizacaoByData(
            response.Item.map((item) => {
              item.dataInclusao = new Date(item.dataInclusao).toISOString();
              return item;
            })
          );

          this.ordenaPrintChatAutorizacaoByData(
            response.Item.map((item) => {
              item.dataInclusao = new Date(item.dataInclusao).toISOString();
              return item;
            }),
            !!chatLojista
          );
        } else {
          this.globalService.presentToast(response.erro, ToastColors.warning);
        }
      })
      .catch((err) => {
        this.globalService.devlog(err);
      })
      .finally(() => loading.dismiss());
  }

  async getJustificativa() {
    let loading = await this.loadingController.create({
      message: 'Carregando...',
    });
    loading.present();

    this.autorizacaoProvicer.getAutorizacoesDeServicoJustificativa(this.id).then((response) => {
      this.globalService.devlog(response);

      if (!response.erro) {
        if (!response.Item) {
          return;
        }

        this.justificativa = response.Item;
      } else {
        this.globalService.presentToast(response.erro, ToastColors.warning);
      }
    }).catch((err) => {
      this.globalService.devlog(err);
    }).finally(() => {
      loading.dismiss()
    });
  }

  async onReplyComm(response: 'aprovar' | 'reprovar' | 'reprovarMsg') {
    let loading = await this.loadingController.create({
      message: 'Aguarde...',
    });

    loading.present();

    let justificativaText = '';

    if (response == 'reprovarMsg') {
      loading.dismiss();

      const alertReprovar = await this.alertCtrl.create({
        header: 'Motivo da reprovação',
        inputs: [{
          placeholder: 'Digite aqui...',
          handler(input) {
            justificativaText = input.value;
          },
        }],
        buttons: [
          {
            text: 'Enviar',
            handler: (value) => {
                return this.onReplyComm('reprovar');
            },
          },
          {
            text: 'Cancelar',
            handler: () => {
              return;
            }
          }
        ]
      })

      alertReprovar.present()
      return;
    }

    //console.log(this.tarefa)

    this.tarefasProvider
      .avaliarComunicacao(
        response == 'aprovar',
        this.tarefa.bdiD_COMUNICACAO || this.tarefa.bdiD_AUTORIZACAO_SERVICO || this.tarefa.idComunicacao,
        this.tarefa['TASK.TKIID'] || this.tarefa.idInstanciaBpm,
        {
          justificativaText
        }
      )
      .then((res) => {
        if (res.erro) {
          this.globalService.presentToast(res.erro, ToastColors.danger);
        } else {
          this.globalService.presentToast(
            `${response === 'aprovar' ? 'Aprovação' : 'Reprovação'} sendo processada com sucesso, aguarde...`,
            ToastColors.success
          );
          this.events.publish('communication.getTarefas', {});
          this.modalCtrl.dismiss();
        }
      })
      .catch((err) => {
        if (err.erro) {
          this.globalService.presentToast(err.erro, ToastColors.danger);
        } else {
          this.globalService.presentToast(
            'Não foi possível responder o comunicado.',
            ToastColors.danger
          );
        }
        this.globalService.devlog(err);
      })
      .finally(() => {
        loading.dismiss();
      });
  }

  // async onReplyAutorizacao(response: 'aprovar' | 'reprovar' | 'cancelar') {
  //   let loading = await this.loadingController.create({
  //     message: 'Aguarde...',
  //   });

  //   loading.present();

  //   if (response == 'reprovar') {
  //     // TODO Modal motivo da reprovação.
  //   }

  //   let idStatusAutorizacaoServico = 2;

  //   if(response == 'reprovar')
  //   {
  //     idStatusAutorizacaoServico = 3;
  //   }
  //   else if(response == 'cancelar')
  //   {
  //     idStatusAutorizacaoServico = 4;
  //   }

  //   this.tarefasProvider
  //     .responderTarefa(
  //       response == 'aprovar',
  //       {
  //         operacao: 'responderAutorizacao',
  //         idAutorizacaoServico: this.tarefa.bdiD_COMUNICACAO || this.tarefa.bdiD_AUTORIZACAO_SERVICO,
  //         idAtividadeBPM: this.tarefa['TASK.TKIID'],
  //         statusAutorizacaoServico: idStatusAutorizacaoServico
  //       }
  //     )
  //     .then((res) => {
  //       if (res.erro) {
  //         this.globalService.presentToast(res.erro, ToastColors.danger);
  //       } else {
  //         this.globalService.presentToast(
  //           `Comunicado ${
  //             response === 'aprovar' ? 'aprovado' : 'reprovado'
  //           } com sucesso!`,
  //           ToastColors.success
  //         );
  //         this.events.publish('communication.getTarefas', {});
  //         this.modalCtrl.dismiss();
  //       }
  //     })
  //     .catch((err) => {
  //       this.globalService.devlog(err);
  //     })
  //     .finally(() => {
  //       loading.dismiss();
  //     });
  // }

  get isAjustarComunicacao(): boolean {
    if (this.tarefa) {
      return this.tarefa.taD_DISPLAY_NAME === 'Ajustar Comunicado';
    } else {
      return false;
    }
  }

  async onEditComm() {
    let modal = await this.modalCtrl.create({
      component: CreateautorizacaoservicoPage,
      componentProps: {
        autorizacaoServico: this.mensagem,
        autorizacaoServicoId: this.id,
        isEdit: true,
        taskId: this.tarefa['TASK.TKIID'],
        tarefa: this.tarefa,
      },
      cssClass: 'bigModal',
    });

    modal.onDidDismiss().then(async (res) => {
      if (res.data.editado) {
        if (this.type == 2) {
          await this.carregarMensagemAutorizacaoServicoApi(this.id);
        } else {
          await this.carregarMensagemComunicadoApi(this.id);
        }

        this.autorizacaoEditada = true;
      }
    });

    await modal.present();
  }

  async onSendAdjust() {
    const loading = await this.loadingController.create({
      message: 'Carregando...',
    });

    loading.present();

    try {
      const res = await this.tarefasProvider.responderTarefa(false, {
        operacao: 'ajustarAutorizacao',
        idAutorizacao: this.id,
        idAtividadeBPM: this.tarefa['TASK.TKIID'],
      });

      if (res?.erro) {
        this.globalService.presentToast(res.erro, ToastColors.danger);
      } else {
        this.globalService.presentToast(
          'Autorização ajustada com sucesso!',
          ToastColors.success
        );
        this.dismiss();
      }
    } catch (error) {
      this.globalService.presentToast(
        'Não foi possível ajustar a autorização.',
        ToastColors.danger
      );

      this.globalService.devlog(error);
      this.loadingController.dismiss();
    } finally {
      loading.dismiss();
    }
  }

  async getLidos(idComunicacao: number) {
    this.loadingLeituras = true;

    this.comunicacaoProvider
      .getLidos(idComunicacao)
      .then(({lidos}) => {
          if (Array.isArray(lidos)) {
            const lidosMap = lidos.map(leitura => {
              return {
                ...leitura,
                contrato: leitura.comunicacaoContrato?.contrato
              }
            })

            this.leituras.naoLidas = lidosMap.filter(
              (x) => x.lido == false
            );
            this.leituras.lidas = lidosMap.filter(
              (x) => x.lido == true
            );
          }
      })
      .finally(() => {
        this.loadingLeituras = false;
      });
  }

  async previewFile(file: any) {
    const loading = await this.loadingController.create({
      message: 'Carregando...',
    });

    loading.present();

    this.autorizacaoProvicer
      .getFilesByIds([file.idArquivo])
      .then((res) => {
        if (Array.isArray(res.rows) && res.rows.length > 0) {
          const file = res.rows[0];

          if (this.isMobile) {
            const url = file.urlDownload;
            const link = document.createElement('a');
            link.setAttribute('href', url);
            link.setAttribute('download', file.nome);
            document.body.appendChild(link);
            link.click();
            link.remove();
          } else {
            const url = file.urlVisualizacao;
            window.open(url, '_blank');
          }
        } else {
          this.globalService.devconsole('Arquivo não encontrado', res);

          this.globalService.presentToast(
            'Arquivo não encontrado para visualização',
            ToastColors.tertiary
          );
        }
      })
      .finally(() => {
        loading.dismiss();
      });
  }

  dismiss() {
    this.modalCtrl.dismiss();
  }

  print() {
    window.print();
  }

  async abrirLeitura(leitura) {
    var temp = [];
    leitura.idComunicacaoNavigation.comunicacaoLeituras.forEach((element) => {
      if (element.numContrato == leitura.numContrato) {
        temp.push(element);
      }
    });

    const popover = await this.popoverController.create({
      component: TimelinereadPage,
      cssClass: 'popover-status',
      arrow: false,
      showBackdrop: false,
      componentProps: {
        lista: temp,
        numContrato: leitura.numContrato,
        lucLoja: leitura.lucLoja
      },
    });
    return await popover.present();
  }
}
